'use strict';

function clone(originalObject) {
  var dupe;
  if (!originalObject) {
    return null;
  }
  dupe = JSON.parse(JSON.stringify(originalObject));
  return dupe;
}
module.exports = clone;